<template>
  <div class="BOX w1200 bbox positionr bgwhite">
    <!-- 收藏 -->
    <div class="positiona likeTool pointer" v-if="isCollect != '0'">
      <i
        v-if="status == false"
        class="el-icon-star-off f22 text999"
        @click="addLike"
      ></i>
      <i
        v-if="status != false"
        class="el-icon-star-on f26 textblue"
        @click="delLike"
      ></i>
    </div>
    <div class="previewArea">
      <div class="previewArea" v-if="'1' == isFile">
        <iframe
          ref="iframe"
          id="iframe"
          class="iframe"
          :src="url"
          width="100%"
          height="100%"
          frameborder="0"
        >
        </iframe>
        <!-- 正在加载 -->
        <div
          v-if="loading"
          class="noMessage positiona"
          style="
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 99999;
          "
        >
          <img src="../assets/images/loading.gif" alt="" width="150" />
        </div>
      </div>
      <div
        class="textc previewArea positionr"
        v-if="'0' == isFile"
        @mouseenter="videoEnter"
        @mouseleave="videoLeave"
      >
        <div class="positiona play" v-if="showFalg == true">
          <img
            src="../assets/images/play_big.png"
            alt=""
            width="70"
            @click="handleShow"
          />
        </div>
        <video
          :src="url"
          controls="controls"
          controlslist="nodownload"
          width="100%"
          height="100%"
          id="media"
        ></video>
        <!-- 正在加载 -->
        <div v-if="loading" class="noMessage positiona" style="z-index: 99999">
          <img src="../assets/images/loading.gif" alt="" width="150" />
        </div>
      </div>
      <div class="textc previewArea positionr" v-if="'2' == isFile">
        <img :src="url" alt="" width="600px" />
        <!-- 正在加载 -->
        <div v-if="loading" class="noMessage positiona" style="z-index: 99999">
          <img src="../assets/images/loading.gif" alt="" width="150" />
        </div>
      </div>
    </div>
    <!-- 描述 -->
    <!-- <div v-if="content.length > 0"
         class="content pl30 pr40">
      <div class="textc f24 fw700 mb30 mt30">{{ $t("describe") }}</div>
      <div v-html="content"></div>
    </div> -->
    <div class="bottom" v-if="this.$route.query.pageStatus != 3">
      <div class="lastView">
        <el-button
          v-if="this.index != 0"
          type="primary"
          style="
            height: 30px;
            width: 40%;
            padding: 0 3px 0 3px;
            position: relative;
            margin-left: 10%;
          "
          @click="lastView"
          >{{ $t("lastArtical") }}
        </el-button>
      </div>
      <div class="thisName">{{ typeName }}</div>
      <div class="nextViev">
        <el-button
          v-if="this.index + 1 != this.list.length"
          type="primary"
          style="
            height: 30px;
            width: 40%;
            padding: 0 3px 0 3px;
            position: relative;
            float: right;
          "
          @click="nextViev"
        >
          {{ $t("nextArtical") }}
        </el-button>
      </div>
      <el-button
        @click="goBack"
        type="primary"
        style="height: 30px; padding: 0 3px 0 3px; margin-left: 50px; width: 5%"
      >
        {{ $t("my.goBack") }}
      </el-button>
    </div>

    <div class="" style="padding: 40px">
      <div style="font-size: 25px; font-weight: bold">注释</div>
      <ul
        style="
          overflow-y: scroll;
          margin: 40px 0;
          padding: 0 100px;
          font-size: 20px;
        "
        :style="changeHeight"
      >
        <li
          style="
            margin: 20px 0;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
          v-for="(item, index) in noteList"
          :key="item.id"
        >
          <div
            style="margin-right: 100px; color: #1BA035"
            @click="go(item)"
          >
            <span>{{ index + 1 }}、</span>
            <span>{{ item.noteName }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
var tips1 = "提示";
var tips2 = "收藏文档成功！";
var tips3 = "收藏失败:";
var tips4 = "取消收藏成功！";
var tips5 = "取消收藏失败：";
var tips6 = "无文件地址，请联系管理员！";
export default {
  data() {
    return {
      url: "",
      isFile: "1",
      typeCode: "",
      typeName: "",
      machineType: "",
      timer: null,
      viewCode: "",
      status: false,
      content: "",
      isCollect: "1",
      showFalg: true,
      loading: false,
      list: [],
      index: 0,
      mainTypeName: "",
      mainTypeCode: "",
      pageStatus: "",
      file: {},
      comments: [], // 注释列表
      noteList: [],
      changeHeight: "height: 200px;"
    };
  },
  methods: {
    load() {
      this.count += 2;
    },
    go(item) {
      var sendData = {};
      sendData.isComment = 1;
      sendData.typeCode = item.noteCode;
      sendData.typeName = item.noteName;
      // sendData.viewCode = this.viewCode;
      sendData.machineType = this.machineType;
      sendData.memberCode = localStorage.getItem("memberCode");
      // var that = this;
      this.$http.post("memberViews/saveViewInfo", sendData).then(function(res) {
        // if (200 == res.data.code) {
        //   that.viewCode = res.data.data;
        // }
      });
      window.open(item.noteContent);
    },
    //返回
    goBack() {
      if (this.pageStatus == 1) {
        this.$router.push({
          path: "/equipmentDetails",
          query: {
            typeName: this.mainTypeName,
            typeCode: this.mainTypeCode
          }
        });
      } else if (this.pageStatus == 2) {
        this.$router.push({ path: "/science" });
      } else {
        this.$router.push({ path: "/tools?from=工具使用" });
      }
    },
    //前一篇
    lastView() {
      if (this.index == 0) {
        this.$message.error({
          message: "已经是第一页了！",
          type: "warning"
        });
      } else {
        this.index = this.index - 1;
        // console.log("this.list[this.index]=" + this.list[this.index])
        var typeCode = this.list[this.index].typeCode;
        var typeName = this.list[this.index].typeName;
        this.showTypeData(typeCode, typeName, this.index);
      }
    },
    //查询Url并展示
    showTypeData(typeCode, typeName, index) {
      var index = index;
      this.previewAreaTittle = typeName;
      this.typeName = typeName;
      var sendData = {};
      sendData.objectCode = typeCode;

      var that = this;
      // console.log(':::::::::::::::::::::::::::::::::::::::::::::::::::');

      that.$http.post("annexFile/queryFileList", sendData).then(function(res) {
        // console.log(';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;');
        if (200 == res.data.code) {
          // this.list = res.data.data
          // console.log('查询Url', res.data.data)
          // console.log('查询Url1', res.data.data[0])
          var file = res.data.data[0];
          if (file != undefined && file.fileUrl != undefined) {
            var tempUrl = file.fileUrl;
            // console.log(tempUrl)
            ///********* */
            if (tempUrl.indexOf(".pdf") != -1) {
              that.isFile = "1";
              that.url =
                "/static/pdf/web/viewer.html?file=" +
                encodeURIComponent(tempUrl);
              that.loading = false;
            }
            if (
              tempUrl.indexOf(".xls") != -1 ||
              tempUrl.indexOf(".xlsx") != -1 ||
              tempUrl.indexOf(".docx") != -1 ||
              tempUrl.indexOf(".doc") != -1 ||
              tempUrl.indexOf(".pptx") != -1 ||
              tempUrl.indexOf(".ppt") != -1
            ) {
              that.isFile = "1";
              that.url = headUrl + tempUrl;
              that.loading = false;
            }
            if (
              tempUrl.indexOf(".mp4") != -1 ||
              tempUrl.indexOf(".mp3") != -1
            ) {
              that.isFile = "0";
              that.url = tempUrl;
              that.loading = false;
            }
            if (
              tempUrl.indexOf(".jpg") != -1 ||
              tempUrl.indexOf(".png") != -1 ||
              tempUrl.indexOf(".jpeg") != -1
            ) {
              that.isFile = "2";
              that.url = tempUrl;
              that.loading = false;
            }
            //   that.url =
            //   "/static/pdf/web/viewer.html?file=" + encodeURIComponent(url);
            // that.$nextTick(() => {
            //   var iframe = that.$refs.iframe;
            //   iframe.att;
            //   if (!(/*@cc_on!@*/ 0)) {
            //     iframe.onload = function () {
            //       var timer = setTimeout(() => {
            //         that.loading = false;
            //       }, 500);
            //       that.contentWindow.document.oncontextmenu = function () {
            //         return false;
            //       };
            //       that.contentWindow.document.onkeydown = function () {
            //         if (event.ctrlKey && window.event.keyCode == 67) {
            //           return false;
            //         }
            //         if (event.ctrlKey && window.event.keyCode == 86) {
            //           return false;
            //         }
            //       };
            //     };
            //   } else {
            //     iframe.onreadystatechange = function () {
            //       if (iframe.readyState == "complete") {
            //         var timer = setTimeout(() => {
            //           that.loading = false;
            //         }, 500);
            //         // clearTimeout(timer);
            //       }
            //     };
            //     that.contentWindow.document.oncontextmenu = function () {
            //       return false;
            //     };
            //     that.contentWindow.document.onkeydown = function () {
            //       if ($event.ctrlKey && window.event.keyCode == 67) {
            //         return false;
            //       }
            //       if ($event.ctrlKey && window.event.keyCode == 86) {
            //         return false;
            //       }
            //     };
            //   }
            // });
          } else {
            that.url = "";
            that.isFile = "";
            that.$message(tips6);
          }
        }
      });
    },
    //后一篇
    nextViev() {
      // console.log('this.index',this.index)
      // console.log('this.list.length-1',this.list.length-1)
      if (this.index >= this.list.length - 1) {
        this.$message.error({
          message: "已经是最后一页了！",
          type: "warning"
        });
      } else {
        this.index = this.index + 1;
        //  console.log('向后', this.index)
        // console.log("this.list[this.index]=" + this.list[this.index])

        var typeCode = this.list[this.index].typeCode;
        var typeName = this.list[this.index].typeName;
        this.showTypeData(typeCode, typeName, this.index);
      }
    },
    //   收藏
    addLike() {
      var sendData = {};
      // var str= this.file.fileName
      // var temp = str.substring(0,str.lastIndexOf(".") )
      sendData.memberCode = localStorage.getItem("memberCode");
      sendData.typeCode = this.typeCode;
      sendData.machineType = this.machineType;
      sendData.typeName = this.typeName;
      // sendData.fileName=temp
      var that = this;
      this.$http
        .post("memberCollect/addMemberCollect", sendData)
        .then(function(res) {
          if (200 == res.data.code) {
            that.$notify.success({
              title: tips1,
              message: tips2,
              showClose: true
            });
            that.status = true;
          } else {
            that.$notify.error();
            ({
              title: tips1,
              message: tips3 + res.data.message,
              showClose: true
            });
          }
        });
    },
    // 取消收藏
    delLike() {
      var sendData = {};
      sendData.memberCode = localStorage.getItem("memberCode");
      sendData.typeCode = this.typeCode;
      var that = this;
      this.$http
        .post("memberCollect/deleteMemberCollect", sendData)
        .then(function(res) {
          if (200 == res.data.code) {
            that.$notify.success({
              title: tips1,
              message: tips4,
              showClose: true
            });
            that.status = false;
          } else {
            that.$notify.success({
              title: tips1,
              message: tips5 + res.data.message,
              showClose: true
            });
          }
        });
    },
    handleShow() {
      var Media = document.getElementById("media");
      this.showFalg = false;
      Media.play();
    },
    countTime() {
      var sendData = {};
      sendData.typeCode = this.typeCode;
      sendData.typeName = this.typeName;
      sendData.viewCode = this.viewCode;
      sendData.machineType = this.machineType;
      sendData.memberCode = localStorage.getItem("memberCode");
      var that = this;
      this.$http.post("memberViews/saveViewInfo", sendData).then(function(res) {
        if (200 == res.data.code) {
          that.viewCode = res.data.data;
        }
      });
    },
    queryCollect() {
      var sendData = {};
      sendData.memberCode = localStorage.getItem("memberCode");
      sendData.typeCode = this.typeCode;
      var that = this;
      this.$http
        .post("memberCollect/queryIsCollect", sendData)
        .then(function(res) {
          if (200 == res.data.code) {
            if ("1" == res.data.data) {
              that.status = true;
            }
          }
        });
    },
    changeLanguage() {
      if (this.$store.getters.language == "zh") {
        tips1 = "提示";
        tips2 = "收藏文档成功！";
        tips3 = "收藏失败:";
        tips4 = "取消收藏成功！";
        tips5 = "取消收藏失败：";
        var tips6 = "无文件地址，请联系管理员！";
      }
      if (this.$store.getters.language == "en") {
        tips1 = "Prompt";
        tips2 = "Collect the document successfully!";
        tips3 = "Collection of failure";
        tips4 = "Unbookmark successfully!";
        tips5 = "Unbookmark failed:";
        var tips6 = "No file address, please contact the administrator！";
      }
      if (this.$store.getters.language == "ja") {
        tips1 = "提示";
        tips2 = "ドキュメントの収蔵に成功!";
        tips3 = "コレクション失敗:";
        tips4 = "キャンセル成功!";
        tips5 = "コレクションをキャンセルするのに失敗しました:";
        var tips6 = "ファイルアドレスがありません。管理者に連絡してください";
      }
    },
    videoEnter() {
      let Media = document.getElementById("media");
      if (Media.paused) {
        this.showFalg = true;
      }
      Media.controls = true;
    },
    videoLeave() {
      let Media = document.getElementById("media");
      this.showFalg = false;
      Media.controls = false;
    },
    getNoteList() {
      let data = {};
      data.typeCode = this.typeCode;
      this.$http
        .post("/machineTypeNote/queryMachineTypeNoteList", data)
        .then(res => {
          // console.log("笔记列表数据", res);
          this.noteList = res.data.data;
          // this.noteList = [
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   },
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   },
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   },
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   },
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   },
          //   {
          //     createCode: "",
          //     createName: "",
          //     createTime: "2024-09-24 21:11:07",
          //     id: 1,
          //     noteCode: "202409242111076790447",
          //     noteContent: "https://testdoc.arkray-service.com.cn/resources/upload/3040%20%E7%BA%BF%E4%B8%8A%E8%AF%81%E4%B9%A6%E6%A8%A1%E6%9D%BF-1_%E6%96%B9%E5%AE%87%E9%BE%99_06SVS2JK.pdf",
          //     noteName: "文件注释",
          //     noteType: "文件",
          //     typeCode: "517743614"
          //   }
          // ]

          if (this.noteList.length > 10) {
            this.changeHeight = "height: 400px;";
          }
        });
    }
  },
  created() {
    this.pageStatus = this.$route.query.pageStatus;
    // console.log(JSON.parse(this.$route.query.queryData));
    this.typeCode = JSON.parse(this.$route.query.queryData).typeCode;

    this.loading = true;
    var headUrl = "https://view.officeapps.live.com/op/view.aspx?src=";

    // console.log('this.list', JSON.parse(this.$route.query.list));

    // console.log('this.index222222222', JSON.parse(this.$route.query.index));
    this.list = JSON.parse(this.$route.query.list);
    this.index = JSON.parse(this.$route.query.index);
    // console.log('this.index轮播=',this.index)
    //机型，学术资料展示
    if (this.$route.query.pageStatus != 3) {
      //翻页
      // this.index = this.$route.query.index;
      // this.index = this.$route.query.list.index;

      // let typeCode = "";
      // let typeName = "";

      // if (this.list.length > 0) {
      //   typeCode = this.list[this.index].typeCode;
      //   typeName = this.list[this.index].typeName;
      // }

      // console.log(this.index, '\\\\\\\\\\\\\\\\\\');

      // console.log(this.list, '+_+_+_+_+_+_+_');

      // if (this.list.length > 0) {
      //   var typeCode = this.list[this.index].typeCode
      //   var typeName = this.list[this.index].typeName
      // }
      this.typeName = JSON.parse(this.$route.query.queryData).typeName;
      this.typeCode = JSON.parse(this.$route.query.queryData).typeCode;
      this.mainTypeName = JSON.parse(this.$route.query.queryData).MainTypeName;
      this.mainTypeCode = JSON.parse(this.$route.query.queryData).MainTypeCode;

      // console.log(this.typeCode, this.typeName, '|||||||||||');

      this.showTypeData(this.typeCode, this.typeName, this.index);
    }

    var preViewFile = this.$route.query.url;
    var data = JSON.parse(preViewFile);

    var tempUrl = data.url;
    if ("0" == data.isCollect) {
      this.isCollect = data.isCollect;
      if (tempUrl.indexOf(".pdf") != -1) {
        this.isFile = "1";
        this.url =
          "/static/pdf/web/viewer.html?file=" + encodeURIComponent(tempUrl);
        this.loading = false;
      }
      if (
        tempUrl.indexOf(".xls") != -1 ||
        tempUrl.indexOf(".xlsx") != -1 ||
        tempUrl.indexOf(".docx") != -1 ||
        tempUrl.indexOf(".doc") != -1 ||
        tempUrl.indexOf(".pptx") != -1 ||
        tempUrl.indexOf(".ppt") != -1
      ) {
        this.isFile = "1";
        this.url = headUrl + tempUrl;
        this.loading = false;
      }
      if (tempUrl.indexOf(".mp4") != -1 || tempUrl.indexOf(".mp3") != -1) {
        this.isFile = "0";
        this.url = tempUrl;
        this.loading = false;
      }
      if (
        tempUrl.indexOf(".jpg") != -1 ||
        tempUrl.indexOf(".png") != -1 ||
        tempUrl.indexOf(".jpeg") != -1
      ) {
        this.isFile = "2";
        this.url = tempUrl;
        this.loading = false;
      }
    } else {
      this.typeCode = data.typeCode;
      this.typeName = data.typeName;
      this.machineType = data.machineType;
      this.content = data.content;
      var that = this;
      if (tempUrl.indexOf(".pdf") != -1) {
        that.url =
          "/static/pdf/web/viewer.html?file=" + encodeURIComponent(tempUrl);
        that.$nextTick(() => {
          var iframe = that.$refs.iframe;
          iframe.att;
          if (!(/*@cc_on!@*/ 0)) {
            iframe.onload = function() {
              that.timer = setTimeout(() => {
                that.loading = false;
              }, 500);
              that.contentWindow.document.oncontextmenu = function() {
                return false;
              };
              that.contentWindow.document.onkeydown = function() {
                if (event.ctrlKey && window.event.keyCode == 67) {
                  return false;
                }
                if (event.ctrlKey && window.event.keyCode == 86) {
                  return false;
                }
              };
            };
          } else {
            iframe.onreadystatechange = function() {
              if (iframe.readyState == "complete") {
                // var timer = setTimeout(() => {
                that.timer = setTimeout(() => {
                  that.loading = false;
                }, 500);
                // clearTimeout(timer);
              }
            };
            that.contentWindow.document.oncontextmenu = function() {
              return false;
            };
            that.contentWindow.document.onkeydown = function() {
              if (event.ctrlKey && window.event.keyCode == 67) {
                return false;
              }
              if (event.ctrlKey && window.event.keyCode == 86) {
                return false;
              }
            };
          }
        });
      }
      if (
        tempUrl.indexOf(".xls") != -1 ||
        tempUrl.indexOf(".xlsx") != -1 ||
        tempUrl.indexOf(".docx") != -1 ||
        tempUrl.indexOf(".doc") != -1 ||
        tempUrl.indexOf(".pptx") != -1 ||
        tempUrl.indexOf(".ppt") != -1
      ) {
        that.url = headUrl + tempUrl;
        that.loading = false;
      }
      if (tempUrl.indexOf(".mp4") != -1 || tempUrl.indexOf(".mp3") != -1) {
        that.isFile = "0";
        that.url = tempUrl;
        that.loading = false;
      }
      if (
        tempUrl.indexOf(".jpg") != -1 ||
        tempUrl.indexOf(".png") != -1 ||
        tempUrl.indexOf(".jpeg") != -1
      ) {
        that.isFile = "2";
        that.url = tempUrl;
        that.loading = false;
      }
      that.queryCollect();
      clearInterval(that.timer);
      that.countTime();
      that.countDownTimer = setInterval(that.countTime, 10 * 1000);
    }
    this.changeLanguage();

    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
    // console.log(this.list, '+++++++++++++++++++++++++=');
  },

  mounted() {
    this.changeLanguage();
    this.getNoteList();

    var that = this;
    var elevideo = document.getElementById("media");
    if (elevideo) {
      elevideo.addEventListener("pause", function() {
        //暂停开始执行的函数
        // console.log("暂停播放");
        that.showFalg = true;
      });
      elevideo.addEventListener("play", function() {
        //开始播放执行的函数
        that.showFalg = false;
      });
    }
  },
  updated() {
    this.changeLanguage();
  }
};
</script>

<style scoped>
.previewArea {
  height: calc(100vh - 155px);
  overflow: hidden;
}

.BOX {
  /* margin: 120px auto 20px auto; */
  /* padding: 50px; */
  padding-bottom: 10px;
  /* width: 1400px; */
  min-height: calc(100vh - 260px);
  width: 70%;
}

/* .Box ::v-deep .textLayer{
  width: 1300px;
} */
.likeTool {
  right: 50px;
  top: 15px;
}

.content {
  border-top: 4px solid #eeeeee;
}

.play {
  top: 50%;
  left: 50%;
  margin-top: -35px;
  transform: translateX(-50%);
  z-index: 100;
}

.bottom {
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  /* margin-left: 34%; */
}

.lastView {
  width: 30%;
  /* background: lightpink; */
}

.thisName {
  width: 30%;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  /* background: #47C297; */
}

.nextViev {
  width: 25%;
  /* background: #5EC95E; */
}
/* 自定义滚动条样式 */
ul::-webkit-scrollbar {
  width: 10px; /* 滚动条宽度，加粗的关键 */
}

ul::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道背景色 */
}

ul::-webkit-scrollbar-thumb {
  background: #888; /* 滚动条滑块颜色 */
  border-radius: 5px; /* 滚动条滑块圆角 */
}

ul::-webkit-scrollbar-thumb:hover {
  background: #555; /* 滚动条滑块悬停颜色 */
}
</style>
